interface Props {
  readonly size?: number;
}

export default function SellIcon(props: Props) {
  const { size = 19 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5 0a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19Zm2.71 5.59h-.1a.8.8 0 0 0-.7.8v3.72L7.12 5.82a.8.8 0 0 0-1.13 1.13l4.3 4.3H6.54a.8.8 0 1 0 0 1.6H13V6.39a.8.8 0 0 0-.8-.8Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
